import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=04f05446&scoped=true"
import script from "./WechatLogin.vue?vue&type=script&lang=ts"
export * from "./WechatLogin.vue?vue&type=script&lang=ts"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=04f05446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f05446",
  null
  
)

export default component.exports